// DOM scope identifiers for the three contexts a `newpageshown` (or sibling)
// event can target. Used by listeners across animations, plugins and other
// frontend modules to scope queries / state to the right .lay-content root.

const SCOPES = {
	NORMAL_PAGE: 'normal_page',
	PROJECT_OVERLAY: 'project_overlay',
	PAGE_OVERLAY: 'page_overlay',
}

const getScopeRoot = function (scope, context) {
	switch (scope) {
		case SCOPES.PROJECT_OVERLAY:
			return document.querySelector('#lay-project-overlay>.lay-content')
		case SCOPES.PAGE_OVERLAY:
			if (context && context.overlayEl) {
				return context.overlayEl.jquery ? context.overlayEl[0] : context.overlayEl
			}
			return document.querySelector('.lay-overlay.lay-show-overlay')
		case SCOPES.NORMAL_PAGE:
		default:
			return document.querySelector('body>.lay-content')
	}
}

const getNavigationScopeForType = function (type) {
	if (type == 'project_overlay') {
		return SCOPES.PROJECT_OVERLAY
	}
	return SCOPES.NORMAL_PAGE
}

// Maps the 4th argument of the `newpageshown` event (`{ isProjectOverlay: bool }`)
// to a SCOPES constant, so listeners can pass it directly to getScopeRoot.
const getScopeForIsProjectOverlay = function (isProjectOverlayObj) {
	if (isProjectOverlayObj && isProjectOverlayObj.isProjectOverlay === true) {
		return SCOPES.PROJECT_OVERLAY
	}
	return SCOPES.NORMAL_PAGE
}

const getScopeForElement = function (element) {
	if (element && typeof element.closest === 'function') {
		if (element.closest('#lay-project-overlay')) return SCOPES.PROJECT_OVERLAY
		if (element.closest('.lay-overlay')) return SCOPES.PAGE_OVERLAY
	}
	return SCOPES.NORMAL_PAGE
}

const getScopeRootForElement = function (element) {
	const scope = getScopeForElement(element)
	if (scope === SCOPES.PAGE_OVERLAY) {
		return getScopeRoot(scope, { overlayEl: element.closest('.lay-overlay') })
	}
	return getScopeRoot(scope)
}

export {
	SCOPES,
	getScopeRoot,
	getScopeRootForElement,
	getNavigationScopeForType,
	getScopeForElement,
	getScopeForIsProjectOverlay,
}
